<template>
  <list-container-widget
    id="mentimeter"
    :title="widgetName"
    :app-id="98"
    stretch
    class="d-flex"
  >
    <iframe :src="mentiUrl" style="border:none;height: 100%; border-radius: 5px;"></iframe>
  </list-container-widget>
</template>

<script>

import WidgetLayoutMixin from '@core/mixins/widgets/WidgetLayoutMixin';
import ToastNotificationsMixin from '@core/mixins/toast-notifications/ToastNotificationsMixin';

import ListContainerWidget from '@core/widgets/ListContainerWidget.vue';

export default {
  name: 'Mentimeter',
  components: { ListContainerWidget },
  mixins: [WidgetLayoutMixin, ToastNotificationsMixin],
  computed: {
    mentiUrl() {
      if(this.item?.customizations != null){
        return this.item?.customizations['Mentimeter-link'];
      }
      return 'https://www.menti.com/';
    },
    item() {
      return this.$store.getters.item('integrations', 'mentimeter');
    },
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch('getItems', {
        itemType: 'addons',
        customName: 'integrations',
        page: 1,
        requestConfig: {
          orderByDate: -1,
          type: 'integrations',
        },
      });
      this.isLoading = false;
    },
  },
};
</script>

